export default __webpack_public_path__ + "static/media/github-search-users.64a95b78.png";